import { useCallback, useEffect, useState } from 'react'
import useStore from '../store/store'
import ApartmentCardMobile from './ApartmentCardMobile';
import NavigationMobile from './mobile/NavigationMobile';
import '../App.scss';
import { _getGuestString } from '../utils/_getGuestString';

const RoomsChoiceMobile = () => {
  const { rooms, roomVariants, activeRoom, step } = useStore();
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);
  const [currentVariants, setCurrentVariants] = useState([]);
  const currentRoom = rooms.find(room => room.id === activeRoom);

  const getVariants = useCallback(() => {
    const currentRoom = rooms.find(room => room.id === activeRoom);
    const peopleCount = currentRoom?.people?.length || 0;
    setCurrentVariants(() => roomVariants[peopleCount])
  }, [activeRoom, roomVariants, rooms]);

  useEffect(() => {
    getVariants()
  }, [getVariants, roomVariants]);

  useEffect(() => {
    const currentRoom = rooms.find(room => room.id === activeRoom);
    if (currentRoom.apartment !== null) setIsBtnDisabled(() => false);
  }, [activeRoom, currentRoom, rooms]);

  return (
    <>
      <div className='MobileMain__wrapper'>
        <div className='MobileMain__step roboto-regular'>Шаг {step}/5</div>

        <h2>Выберите номер {rooms.length > 1 && currentRoom.id + 1}</h2>
        <span className='MobileMain__subtitle'>{_getGuestString(currentRoom.people).replace('(', '').replace(')', '')}</span>

        <div className='RoomChoice__card-wrapper'>
          {currentVariants.map((item) => (<ApartmentCardMobile key={item.rid} item={item} />))}
        </div>
        <NavigationMobile isBtnDisabled={isBtnDisabled} setIsBtnDisabled={setIsBtnDisabled} />
      </div>
    </>
  )
}

export default RoomsChoiceMobile